import { VoiceModel } from "@/actions/db/get-models";
import VoiceSelectorBase from "@/components/common/voice-selector/selectors/base/voice-selector-base";
import DefaultTopBar from "@/components/common/voice-selector/top-bars/default-top-bar";
import React from "react";
import { useDuetsVoiceSelect } from "@/components/common/voice-selector/hooks/use-duets-voice-select";

type DuetsVoiceSelectorProps = {
  selectedVoices: VoiceModel[];
  handleVoiceModelClick: (voice: VoiceModel) => void;
};

const DuetsVoiceSelector = ({
  selectedVoices,
  handleVoiceModelClick,
}: DuetsVoiceSelectorProps) => {
  const duetsVoiceSelect = useDuetsVoiceSelect(selectedVoices);

  return (
    <VoiceSelectorBase
      {...duetsVoiceSelect}
      handleVoiceModelClick={handleVoiceModelClick}
    >
      <DefaultTopBar {...duetsVoiceSelect} />
    </VoiceSelectorBase>
  );
};

export default DuetsVoiceSelector;
